import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import RemCalc from '../../utils/rem-calc';

export const BladeCtaContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  &:last-child {
    margin-bottom: 0;
  }

  p {
    line-height: 1.5em;
    margin-bottom: 1.5em;
  }
`;

export const BladeCtaImage = styled.div`
  width: ${RemCalc(220)};
  max-width: 100%;
  margin-bottom: 1rem;
`;

export const BladeCtaLinks = styled.div`
  width: 100%;
  display: flex;
  align-items: center;

  @media (max-width: ${themeGet('breakpoints.xs')}) {
    flex-wrap: wrap;
  }

  a,
  button {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;

    &:first-child {
      margin-left: 0;
    }

    &:last-child {
      margin-right: 0;
    }

    @media (max-width: ${themeGet('breakpoints.xs')}) {
      width: 100%;
      margin-left: 0;
      margin-right: 0;
    }
  }
`;
